import React, { useContext } from 'react';
import QuestionString from '@/components/pages/assessments/questions/QuestionString';
import QuestionYesNo from '@/components/pages/assessments/questions/QuestionYesNo';
import QuestionInteger from '@/components/pages/assessments/questions/QuestionInteger';
import QuestionOptions from '@/components/pages/assessments/questions/QuestionOptions';
import QuestionDate from '@/components/pages/assessments/questions/QuestionDate';
import QuestionSelect from '@/components/pages/assessments/questions/QuestionSelect';
import QuestionCount from '@/components/pages/assessments/questions/QuestionCount';
import QuestionLocation from '@/components/pages/assessments/questions/QuestionLocation';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const AssessmentOptions = ({ answer, handleAnswer, question, setStepCanProceed, optionMapping }) => {
  const { css } = useContext(displayContext);

  const q = question.question;

  const jsx = () => {
    switch (q.value_type) {
      case 'string':
        return <QuestionString key={q.id} question={q} answer={answer} setAnswer={handleAnswer} setQuestionComplete={setStepCanProceed} />;
      case 'yes_no':
        return <QuestionYesNo key={q.id} question={q} answer={answer} setAnswer={handleAnswer} setQuestionComplete={setStepCanProceed} />;
      case 'integer':
        return <QuestionInteger key={q.id} question={q} answer={answer} setAnswer={handleAnswer} setQuestionComplete={setStepCanProceed} />;
      case 'options':
      case 'multiple_options':
      case 'multiple_options_with_none':
        return (
          <QuestionOptions
            key={q.id}
            question={q}
            answer={answer}
            setAnswer={handleAnswer}
            setQuestionComplete={setStepCanProceed}
            allowMultiple={q.value_type.indexOf('multiple') > -1}
            includeNone={q.value_type === 'multiple_options_with_none'}
            optionMapping={optionMapping}
          />
        );
      case 'select':
        return <QuestionSelect key={q.id} question={q} answer={answer} setAnswer={handleAnswer} setQuestionComplete={setStepCanProceed} />;
      case 'count':
        return <QuestionCount key={q.id} question={q} answer={answer} setAnswer={handleAnswer} setQuestionComplete={setStepCanProceed} />;
      case 'age':
      case 'date':
        return <QuestionDate key={q.id} question={q} answer={answer} setAnswer={handleAnswer} setQuestionComplete={setStepCanProceed} />;
      case 'location':
        return <QuestionLocation key={q.id} question={q} answer={answer} setAnswer={handleAnswer} setQuestionComplete={setStepCanProceed} />;
      default:
        return <div key={q.id}>not implemented: {q.value_type}</div>;
    }
  };

  return (
    <Row className={css('assessment-options')}>
      <Col className={`${css('assessment-column-padding')}`}>{jsx()}</Col>
    </Row>
  );
};

export default AssessmentOptions;
